import Portfolio from "../components/Portfolio";

const PortfolioPage = (p) => {
  return <Portfolio />;
};
export default PortfolioPage;
